import React from "react";
import { Button, Modal } from "rsuite";
import { TypeAttributes } from "rsuite/esm/@types/common";

export const CustomModal = ({
  title,
  children,
  component,
  modalSize,
  notCloseOnOk,
  onOk,
  titleHeader
}: {
  title?: string;
  component: JSX.Element;
  children: React.ReactNode;
  modalSize?: TypeAttributes.Size | undefined;
  notCloseOnOk?: boolean;
  onOk?: () => void;
  titleHeader?: JSX.Element;
}) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="modal-container">
      <div className="click" onClick={handleOpen}>
        {component}
      </div>

      <Modal open={open} onClose={handleClose} size={modalSize}>
        <Modal.Header>
          {title && <Modal.Title>{title}</Modal.Title>}
          {titleHeader && titleHeader}
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              onOk && onOk();
              !notCloseOnOk && handleClose();
            }}
            appearance="primary"
          >
            Ok
          </Button>
          <Button onClick={handleClose} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
